import React from "react";
import * as S from "./styles";
import CompTextField from "components/CompTextField";
import { convertDateFromApi, getIrregularityTypeLabel } from "utils";
import { lightBackground, lightVerde } from "styles/variables";
import stylesCompTextField from "components/CompTextField/styles";
import { Grid, Typography, Box } from "@mui/material";

const Forms = ({
  isEdit,
  isView,
  beneficiaryData = null,
  register,
  unregister,
  errors,
}) => {
  const renderIrregularities = () => {
    const styleBox = (active) => ({
      backgroundColor: active ? lightVerde : lightBackground,
      padding: "4px 12px",
      borderRadius: "12px",
      color: active ? "white" : "black",
      marginLeft: "12px",
    });

    return (
      <Box sx={{ width: "100%", mt: 2 }}>
        <Typography
          variant="h6"
          sx={{ ...stylesCompTextField.textFieldLabel, mb: 1 }}
        >
          IRREGULARIDADES
        </Typography>
        <Box sx={{ ...stylesCompTextField.viewContainer, p: 2, width: "100%", minWidth: "73vw",  mx: "auto" }}>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1, 
      }}
    >
      {beneficiaryData?.benefit_irregularities?.map((irregularity, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1, 
          }}
        >
          <Typography variant="body1">
            {getIrregularityTypeLabel(irregularity.code)}
          </Typography>
          <Box sx={{ ...styleBox(irregularity.active) }}>
            {irregularity.active ? "Ativa" : "Inativa"}
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
</Box>
    );
  };

  return (
    <S.Form>
      <S.FormRowDatas>
        {/* Linha 1 */}
        <CompTextField
          isView={isView}
          edit={isEdit}
          apiText={convertDateFromApi(
            beneficiaryData?.end_date
          )?.toLocaleDateString("pt-BR")}
          textLabel="DATA DE EXPIRAÇÃO DO BENEFÍCIO:"
          fromNis={true}
          placeholder="dd/mm/aaaa"
          enabled={false}
          required
          style={{ flexGrow: "1" }}
          name="end_date"
          register={register}
          unregister={unregister}
          error={errors.end_date}
          helperText={errors.end_date && errors.end_date.message}
        />
      </S.FormRowDatas>
      {(isEdit || isView) && beneficiaryData?.benefit_irregularities?.length > 0 && renderIrregularities()}
    </S.Form>
  );
};

export default Forms;

